import { Button, Col, Row } from "antd";
import { useMemo } from "react";
import { type SubmitHandler, useForm } from "react-hook-form";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Page from "../../Common/Page";
import LoaderContainer from "../../Common/Page/LoaderContainer";
import PermissionCheck from "../../Common/PermissionCheck";
import FormControl from "../../components/Form/FormControl";
import { StyledFormInputs } from "../../components/Form/StyledFormInputs";
import { useCreateLeadersQualification } from "../../entities/api";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import { useGetOrgData } from "../../hooks/useGetOrgData";

const PermissionName = PermissionNames.LEADER_QUALIFIER;

interface IFormInput {
  name: string;
}

const ManageLeadersQualification = () => {
  const { sport, organizationId, customerId } = useGetOrgData();
  const { formatMessage } = useIntl();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<IFormInput>();
  const { mutate: createFn, isPending: isCreatePending } = useCreateLeadersQualification();

  const title = useMemo(() => {
    return `${formatMessage({
      id: "leaders.qualification.create",
      defaultMessage: "Create Leaders Qualification Template",
    })}`;
  }, [formatMessage]);

  const onSubmit: SubmitHandler<IFormInput> = (data) => {
    // @ts-ignore
    createFn(data);
  };

  return (
    <Page title={title} tabTitle={title}>
      <LoaderContainer loading={isCreatePending}>
        <Content>
          <form style={{ marginLeft: 20, width: 960 }} onSubmit={handleSubmit(onSubmit)}>
            <Row style={{ maxWidth: 960 }} gutter={16}>
              <Col span={12}>
                <Row gutter={16}>
                  <Col span={16}>
                    <FormControl
                      labelText="name"
                      name="name"
                      labelTooltip={formatMessage({
                        id: "form.help.leaders.qualification.name",
                      })}
                      rules={{
                        required: formatMessage(
                          {
                            id: "form.help.required.field",
                          },
                          {
                            field: formatMessage({
                              id: "name",
                            }),
                          },
                        ),
                      }}
                      control={control}
                      render={({ field }) => <StyledFormInputs {...field} />}
                      errors={errors}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <PermissionCheck permissionKeys={[PermissionName]} permissionOptions={[PermissionOperations.CREATE]}>
                <Button htmlType="submit" type="primary">
                  {formatMessage({
                    id: "leaders.qualification.create",
                  })}
                </Button>
              </PermissionCheck>
              <Link to={`/${customerId}/admin/${sport}/${organizationId}/sites`}>
                <Button style={{ marginLeft: 30 }} type="primary">
                  {formatMessage({ id: "close" })}
                </Button>
              </Link>
            </Row>
          </form>
        </Content>
      </LoaderContainer>
    </Page>
  );
};

const Content = styled.div`
  display: flex;

  .container {
    margin: 0;
  }
`;

export default ManageLeadersQualification;
